import { type AppEnvT } from '@ruminati/types_v2/env'

export function isNewStandardsReportingEnabled(appEnv: AppEnvT): boolean {
  return appEnv === 'local' || appEnv === 'dev' || appEnv === 'test' || appEnv === 'staging'
}

/**
 * Alpha features are available in local/dev and non-user test environments.
 * They are intentionally unavailable in staging and production.
 */
export function isAlphaFeatureEnabled(appEnv: AppEnvT): boolean {
  return appEnv === 'local' || appEnv === 'dev' || appEnv === 'test' || appEnv === 'e2e'
}
